import React, { useEffect } from "react";
import * as qs from "qs";
import { FullScreenLoader } from "../../components";
import { getGoogleAuthURL } from "../../utils/helpers";
import { encryptEmail } from "../../utils/helpers";
import { useLocation } from "react-router-dom";

const GoogleLoginScreen = () => {
  const location = useLocation();
  const host = qs.parse(window.location.search?.slice(1))?.host;

  useEffect(() => {
    const isMailAcess = location?.search?.includes("mail_access=true");
    const isCalendarAccess = location?.search?.includes("calendar_access=true");
    const googleURL = getGoogleAuthURL(isMailAcess, isCalendarAccess);
    const encryptedEmail = encryptEmail(host);

    localStorage.setItem("host", encryptedEmail);
    const anchor = document.createElement("a");
    anchor.href = googleURL;
    anchor.click();
  }, [host]);
  return <FullScreenLoader />;
};

export default GoogleLoginScreen;
